import { fetchData, apiURL } from "../api-helper";

// STATISTICS

// GET DASHBOARD STATISTICS
const getDashBoardStatistics = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/statistics/dashboard`;
    fetchData(endpointURL, "get", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

// GET CAPACITY STATISTICS
const getCapacityStatistics = () =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/statistics/capacity`;
    fetchData(endpointURL, "get", null)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

// EXPORT TABLE
const exportTable = () =>
  new Promise((resolve, reject) => {
    fetchData(
      "https://file-examples.com/wp-content/storage/2017/02/file_example_XLS_100.xls",
      "get",
      null
    )
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getSalesStatistic = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/orders/summary`;
    fetchData(endpointURL, "get", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

export default {
  getDashBoardStatistics,
  getCapacityStatistics,
  exportTable,
  getSalesStatistic,
};
